import { useEffect } from "react";
import { useOnboarding } from "../../contexts/OnboardingContext";
import "./EditorTourHighlighter.css";

export const STEP_TARGETS = {
  "editor-tour-save": '[data-onboarding="save-project"]',
  "editor-tour-tools": '[data-onboarding="editor-menu"]',
  "editor-tour-zoom": '[data-onboarding="zoom-controls"]',
  "editor-tour-video": '[data-onboarding="video-tutorial"]',
  "editor-tour-designer": '[data-onboarding="designer-launch"]',
};

const EditorTourHighlighter = () => {
  const { isOnboardingActive, currentFlow, currentStep } = useOnboarding();

  useEffect(() => {
    const highlighted = document.querySelectorAll(".editor-tour-highlight");
    highlighted.forEach((node) => node.classList.remove("editor-tour-highlight"));

    if (!isOnboardingActive || currentFlow !== "editorTour") {
      return undefined;
    }

    const selector = STEP_TARGETS[currentStep];
    if (!selector) {
      return undefined;
    }

    const target = document.querySelector(selector);
    if (!target) {
      return undefined;
    }

    target.classList.add("editor-tour-highlight");
    target.scrollIntoView({
      block: window.innerWidth <= 768 ? "center" : "nearest",
      inline: "nearest",
      behavior: "smooth",
    });

    return () => {
      target.classList.remove("editor-tour-highlight");
    };
  }, [currentFlow, currentStep, isOnboardingActive]);

  return null;
};

export default EditorTourHighlighter;
